import { render, staticRenderFns } from "./LayoutSettings.vue?vue&type=template&id=b1d7876a&scoped=true"
import script from "./LayoutSettings.vue?vue&type=script&lang=js"
export * from "./LayoutSettings.vue?vue&type=script&lang=js"
import style0 from "./LayoutSettings.vue?vue&type=style&index=0&id=b1d7876a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d7876a",
  null
  
)

export default component.exports